module.exports = __webpack_public_path__ + "static/media/28.4f97d456.mp3";